import { render, staticRenderFns } from "./CodeViewer.vue?vue&type=template&id=34f067cc&scoped=true&"
import script from "./CodeViewer.vue?vue&type=script&lang=js&"
export * from "./CodeViewer.vue?vue&type=script&lang=js&"
import style0 from "./CodeViewer.vue?vue&type=style&index=0&id=34f067cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f067cc",
  null
  
)

export default component.exports